var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCAgenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5916 6.28711H14.0547V16.0149H23.0635V14.4935H15.5916V6.28711Z",
    fill: "#F07F3C",
    stroke: "#F07F3C",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5166 1.00006C8.07606 0.978407 2.0098 7.06504 2.00001 14.5634C1.99022 21.9741 7.92428 28.0061 15.2885 28.1271L13.3682 29.5541L14.2755 30.7852L17.6171 28.3028L15.2772 23.9329L13.9332 24.6621L14.9526 26.5664C8.74144 26.2805 3.59369 21.1794 3.55305 14.6288C3.51241 7.99255 8.80019 2.64005 15.3262 2.55099C21.9555 2.45898 27.4342 7.78293 27.4739 14.557C27.4737 16.297 27.0971 18.0162 26.3703 19.5955C26.8004 19.9211 27.1894 20.2982 27.5287 20.7184C28.4955 18.8137 28.9997 16.706 29 14.5678C29.0112 7.09161 22.9788 1.0222 15.5166 1.00006Z",
    fill: "#F07F3C",
    stroke: "#F07F3C",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCAgenda);
export default __webpack_public_path__ + "static/media/c_agenda.f6bdae35b05ba5a440cc50c16730220d.svg";
export { ForwardRef as ReactComponent };